import { render, staticRenderFns } from "./KeywordAdd.vue?vue&type=template&id=489fadf7&scoped=true&"
import script from "./KeywordAdd.vue?vue&type=script&lang=js&"
export * from "./KeywordAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fadf7",
  null
  
)

export default component.exports